import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import SwiperCore, { SwiperOptions, Autoplay } from 'swiper';
SwiperCore.use([Autoplay]);

@Component({
	selector: 'app-partner-list',
	templateUrl: './partner-list.component.html',
	styleUrls: ['./partner-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class PartnerListComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
	@ViewChild('swiperContainer') private swiperContainer?: ElementRef<HTMLElement>;

	@Input() partners: Array<any>;
	@Input() conf: number;
	@Input() page: string;

	private swiper?: SwiperCore;
	private viewInitialized = false;

	config: SwiperOptions = {
		slidesPerView: 1,
		spaceBetween: 10,
		loop: true,
		autoplay: {
			delay: 2000,
		},
		breakpoints: {
			480: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			640: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 40,
			},
			1024: {
				slidesPerView: 6,
				spaceBetween: 50,
			},
		},
	};

	constructor() {}

	ngOnInit(): void {}

	ngAfterViewInit(): void {
		this.viewInitialized = true;
		this.initializeSwiper();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.partners) {
			this.initializeSwiper();
		}
	}

	ngOnDestroy(): void {
		this.swiper?.destroy(true, true);
	}

	private initializeSwiper(): void {
		if (!this.viewInitialized || !this.partners || this.partners.length <= 6) {
			return;
		}

		Promise.resolve().then(() => {
			if (!this.swiperContainer?.nativeElement) {
				return;
			}

			this.swiper?.destroy(true, true);
			this.swiper = new SwiperCore(this.swiperContainer.nativeElement, this.config);
		});
	}
}
